import axiosClient from '@/services/axios';
import { createAsyncThunk } from '@reduxjs/toolkit';

const fetchSimilarProducts = createAsyncThunk(
  'similarProducts/fetchSimilarProducts',
  async ({ slug, categoryIds }, { rejectWithValue }) => {
    try {
      const body = {
        slug,
        categoryIds,
      };
      const response = await axiosClient.post(`/api/similar-products`, body, {
        'Content-Type': 'application/json',
      });
      return response?.data?.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data || err.message);
    }
  },
);

export default fetchSimilarProducts;
